"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ComponentCondition = void 0;
var cond_1 = __importDefault(require("lodash/cond"));
var matches_1 = __importDefault(require("lodash/matches"));
var constant_1 = __importDefault(require("lodash/constant"));
var stubTrue_1 = __importDefault(require("lodash/stubTrue"));
function ComponentCondition(value, cases, args) {
    var conditions = __spreadArrays(cases.map(function (_a) {
        var key = _a[0], component = _a[1];
        return [matches_1.default(key), constant_1.default(component)];
    }), [
        [stubTrue_1.default, constant_1.default(null)],
    ]);
    var getComponent = cond_1.default(conditions)(value);
    return getComponent(args);
}
exports.ComponentCondition = ComponentCondition;
